import { Icon } from '@design-system/icon';
import { LinkProps } from '@design-system/link';
import classNames from 'classnames';
import { Link } from 'gatsby';
import React, { ReactElement, useContext } from 'react';

import { ExternalLinkDialogContext } from '~/context/ExternalLinkDialogContext';

const TMPLinkWrap = ({
  variant = 'primary',
  size = 'small',
  children,
  className,
  iconPrefix,
  iconSuffix,
  href,
  onClick,
  ...htmlProperties
}: LinkProps): ReactElement => {
  const IconPrefixComponent = iconPrefix?.component || Icon;
  const IconSuffixComponent = iconSuffix?.component || Icon;

  const { displayModal } = useContext(ExternalLinkDialogContext);

  const isInternal = /(^\/(?!\/))/.test(href);
  const isAnchorLink = /(^#)/.test(href);

  const commonProps = {
    className: classNames(
      'cds-link',
      className,
      `cds-link--${variant}`,
      `cds-link--${variant}-${size}`
    ),
    ...htmlProperties,
  };

  const content = (
    <>
      {iconPrefix?.props && (
        <IconPrefixComponent
          className={classNames('icon__prefix', `icon--${variant}-icon`)}
          {...iconPrefix.props}
        />
      )}
      <span
        className={classNames('cds-link__inner', {
          'cds-sr-only': variant.includes('-icon'),
        })}
      >
        {children}
      </span>
      {iconSuffix?.props && (
        <IconSuffixComponent
          className={classNames('icon__suffix', `icon--${variant}-icon`)}
          {...iconSuffix.props}
        />
      )}
    </>
  );

  if (isInternal) {
    return (
      <Link to={href} {...(commonProps as any)} onClick={onClick}>
        {content}
      </Link>
    );
  }

  if (isAnchorLink) {
    return (
      <a href={href} {...commonProps}>
        {content}
      </a>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => displayModal(e, href, onClick)}
      {...commonProps}
    >
      {content}
    </a>
  );
};

export default TMPLinkWrap;
